import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import { formatTokens, parseDate } from 'helpers/date_utils';

import './styles.scss';

export default function NextCriticalDate({ deal }) {
  if (!deal.nextCriticalDate.date) return null;

  const { date, label } = deal.nextCriticalDate;
  const criticalDate = parseDate(date);
  const differentYear = criticalDate.getFullYear() !== new Date().getFullYear();

  return (
    <div className="next-critical-date">
      <div className={classNames('date', { 'date-with-year': differentYear })}>
        {differentYear && <div className="critical-date-year">{formatTokens(criticalDate, 'YYYY')}</div>}
        <div className="critical-date-month">{formatTokens(criticalDate, 'MMM').toUpperCase()}</div>
        <div className="critical-date-day">{formatTokens(criticalDate, 'D')}</div>
      </div>
      <div className="critical-date-name">
        <a href={deal.path + '/planner'}>{label}</a>
      </div>
    </div>
  );
}

NextCriticalDate.propTypes = {
  deal: PropTypes.shape({
    nextCriticalDate: PropTypes.object.isRequired,
  }).isRequired,
};
